import { render } from "./TrocarSenha.vue?vue&type=template&id=3e59f6fa&ts=true"
import script from "./TrocarSenha.vue?vue&type=script&lang=ts"
export * from "./TrocarSenha.vue?vue&type=script&lang=ts"

import exportComponent from "/home/arthur/ProjetoVue/revista/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__